const featuredColorSwatchButtons = document.querySelectorAll(
  ".product__color-swatch"
);

function handleImageSwitch(e) {
  console.log("qwerty");
  featuredColorSwatchButtons.forEach((btn) => {
    btn.classList.remove("selected");
  });

  e.target.classList.add("selected");

  const productItem = e.target.closest(".product-item");
  if (productItem) {
    const productItemImage = productItem.querySelector(
      ".product-item__image img"
    );
    const variantData = JSON.parse(e.target.getAttribute("data-variant-data"));

    productItemImage.setAttribute("src", variantData.featured_image.src);
    productItemImage.setAttribute("srcset", variantData.featured_image.src);
  }
}

featuredColorSwatchButtons.forEach((button) => {
  button.addEventListener("click", (e) => handleImageSwitch(e));
});

// header links logic on click
const headerLinks = document.querySelectorAll(".header .link-header-a");
function checkSideBar() {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  )
    headerLinks.forEach((link) => link.classList.add("no-transition"));
  else headerLinks.forEach((link) => link.classList.remove("no-transition"));
}
checkSideBar();

// collection page
if (document.querySelector(".template-collection")) {
  const filterItem = document.querySelectorAll(
      ".collection-sidebar__group li.filter-item"
    ),
    filterTrigger = document.querySelector(".filterTrigger");

  filterItem.forEach((item) => {
    item.addEventListener("click", () => {
      item.parentNode.previousElementSibling.click();
    });
  });

  filterTrigger.addEventListener("click", () => {
    if (filterTrigger.classList.contains("show-filt")) {
      filterTrigger.classList.remove("show-filt");
      $(".filters-wrapper-mob").hide(500);
    } else {
      filterTrigger.classList.add("show-filt");
      $(".filters-wrapper-mob").show(500);
    }
  });
}
